export const R = {
	"YouHaveBlockingConsultation": "Du har nået grænsen for kommende konsultationer.",
	"BlockingConsultationMessage": "For at minimere ventetiden er der en øvre grænse for, hvor mange kommende konsultationer du kan have hos en specialist ad gangen.",
	"BlockingConsultationMessage2": "Hvis du vil bestille en ny konsultation, skal du først aflyse en eksisterende. Du kan aflyse dine aftaler via",
	"TheConsultationList": "konsultationslisten",
	"WhoNeedsHelp": "Hvem har brug for hjælp?",
	"Myself": "Mig selv ({0})",
	"AddPet": "Tilføj kæledyr",
	"AddChildUnderCertainAge": "Opprett barn under {0} år",
	"AddFirstChild": "Mitt barn under {0} år",
	"Ok": "Ok",
	"HowDoYouWantToContact": "Hvordan vil du kontakte {0}?",
	"TextConsultations": "Tekstkonsultation",
	"PerConsultation": "pr. konsultation",
	"Free": "Gratis",
	"Back": "Tilbage",
	"VideoConsultations": "Videokonsultasjoner",
	"DisclaimerHeader": "Vigtig information",
	"DisclaimerButtonText": "Accepter og fortsæt",
	"PhoneNumberLabel": "Dit telefonnummer\n",
	"SubjectRequired": "Emne skal udfyldes",
	"MessageRequired": "Udfyld venligst en besked",
	"PhoneRequired": "Angiv venligst telefonnummer. Så kan vi få fat på dig, hvis teknikken driller.",
	"InvalidPhoneNumber": "Indtast venligst et gyldigt telefonnummer",
	"Confirm": "Bekræft",
	"ConfirmAndSend": "Bekræft og send",
	"PhoneFormDescription": "Skulle der opstå tekniske problemer, kontakter lægen dig telefonisk. Tjek derfor at dit telefonnummer er korrekt.",
	"PhoneFormHeader": "Bekræft dit telefonnummer",
	"NotifyOwnDoctorDescription": "For at sikre dig det bedste behandlingsforløb vil vi i nogle tilfælde orientere din egen læge om, hvad vi har behandlet dig for hos Hejdoktor. Det er vigtigt, at din egen læge f.eks. ved hvilken medicin, du har fået ordineret eller hvilke råd, vi har givet dig.",
	"NotifyOwnDoctorHeader": "Må din egen læge få besked om din behandling?",
	"Yes": "Ja",
	"No": "Nej",
	"DescribeProblemHeader": "Hvad har du brug for hjælp til?",
	"SubjectLabel": "Emne",
	"MessageLabel": "Besked",
	"SubjectPlaceholder": "Kort beskrivelse af emnet",
	"MessagePlaceholder": "Beskriv dit problem så detaljeret som muligt",
	"ImportantInfoHeader": "Ved behov for akut hjælp",
	"Next": "Næste",
	"BookOrQueueUpHeader": "Book tid",
	"QueueUpDescription": "Stil dig i kø og bliv forbundet til næste ledige behandler.",
	"WaitingTime": "Ventetid:&lt;br /&gt;Cirka &lt;b&gt;{0} minutter&lt;/b&gt;",
	"QueueUpButtonText": "Stil dig i kø",
	"BookConsultation": "Book konsultation",
	"SelectCaregiverTitle": "Hvem vil du snakke med?",
	"SelectCaregiverDescription": "Vælg venligst en behandler. Du vælger din tid i næste trin.",
	"TermsOfService1": "Ved at klikke på knappen ovenfor accepterer du Hejdoktors",
	"TermsOfService2": "handelsbetingelser",
	"YouCanAlsoMessageUs1": "Du kan også skrive til os.",
	"YouCanAlsoMessageUs2": "Du får svar i løbet af 24 timer.",
	"AttachFiles": "Tilføj filer",
	"FileTooLargeErrorMessage": "Filen er for stor (max 30 mb)",
	"DuplicateNameErrorMessage": "Du har uploadet en fil med samme navn",
	"ErrorFetchingTimetable": "Tidsplanen kunne ikke indlæses. Prøv igen, og kontakt os gerne hvis problemet fortsætter.",
	"ErrorFetchingWaitingTime": "Den forventede ventetid kunne ikke indlæses. Prøv igen, og kontakt os gerne hvis problemet fortsætter.",
	"ErrorFetchingCaregivers": "Tilgængelige behandlere kunne ikke indlæses. Prøv igen, og kontakt os gerne hvis problemet fortsætter.",
	"Today": "I dag",
	"TimeZoneWarning": "Tidspunkterne vises i din lokale tidszone: {0}",
	"OutsideOpeningHours": "Det er uden for åbningstid, så du kan ikke stille dig i kø til en konsultation. I stedet kan du booke en konsultation nedenfor.",
	"PleaseChooseDate": "Vælg venligst en tid for din konsultation",
	"InvalidPayment": "Ugyldig betaling",
	"AllCaregivers": "Alle behandlere",
	"TimeslotUnavailable": "Tiden er desværre allerede booket, vælg venligst et andet tidspunkt.",
	"ErrorSchedulingConsultation": "Der opstod en fejl under booking af konsultationen. Prøv venligst igen, eller kontakt os hvis problemet fortsætter.",
	"UnsupportedDeviceVideo": "Video-kald fungerer desværre ikke i denne browser eller enhed. Du kan stadig bestille din konsultation her, men for at gennemføre samtalen er du nødt til at benytte en anden browser eller hente vores app.",
	"NoAvailableTimeslotsHeader": "Øv! Der er ingen ledige tider i den nærmeste fremtid",
	"NoAvailableTimeslotsDescription": "Skriv til os på &lt;a href=\"mailto:hej@hejdoktor.dk\"&gt;hej@hejdoktor.dk&lt;/a&gt;, hvis du vil høre mere om, hvornår vi igen har mulighed for at hjælpe dig.",
	"NoTimeslotsForCaregiverOnSelectedDay": "Ingen tilgængelige tider. Vælg en anden dag eller behandler.",
	"AvailableFrom": "Ledig fra: {0}",
	"FileRejectionsHeader": "Følgende filer blev ikke uploadet",
	"MaxUploadsReached": "Maksimum antal filer (10) er nået",
	"AttachmentUploadFailed": "En eller flere filer kunne ikke uploades. Din besked blev ikke sendt. Prøv venligst igen, eller kontakt os hvis problemet fortsætter.",
	"AttachmentsRequiredErrorMessage": "Du skal vedhæfte minimum 1 billede eller video for at booke denne konsultation.",
	"PrescriptionQuestions": " - Hvorfor mangler du medicinen?\n - Hvad er navnet på medicinen?\n - Hvilken dosis plejer du at få?\n - Hvad får du medicinen for?",
	"AiNurseModalHeader": "Må vi stille dig et par opfølgende spørgsmål?",
	"AiNurseModalDescription": "Vi bruger AI til at sikre, at din besked indeholder alle de oplysninger, som lægen har brug for, for at hjælpe dig bedst muligt.\n\nBemærk: AI kan lave fejl, så besvar kun det, du finder relevant. Dine data anvendes ikke til træning af AI-modeller.",
	"Skip": "Spring over",
	"GoToQuestion": "Gå til spørgsmål",
	"AiNurseQuestionsHeader": "Besvar spørgsmål",
	"AiNurseOverviewHeader": "Din besked til lægen",
	"AiNurseOverviewDescription": "Her kan du se din samlede besked til lægen. Tjek gerne, om alt ser rigtigt ud, før du sender.",
	"AiNurseSubjectTag": "Emne",
	"AiNurseUpdatedMessageTag": "Opdateret besked til lægen",
	"AiNurseQuestionsSubheader": "Hjælpespørgsmål genereret med AI",
	"AiNurseEditMessage": "Ret besked",
	"AiNurseSendMessage": "Send besked",
	"AiNurseSaveAndContinue": "Gem og gå videre",
	"AiNurseAnswerPlaceholder": "Skriv svaret ditt her",
	"InsuranceProviderInfoCardWithProviderTitle": "Denne behandlingen er ikke gratis via {0}",
	"InsuranceProviderInfoCardWithProviderParagraph1": "Behandlingen er ikke dekket av din gratis dekning gjennom {0}.",
	"InsuranceProviderInfoCardWithProviderParagraph2": "Hvis du har tilgang gjennom en annen samarbeidspartner som dekker denne behandlingen, må du koble den til i profilen din før du booker.",
	"InsuranceProviderInfoCardNoProviderTitle": "Har du tilgang til Hejdoktor gjennom en av våre samarbeidspartnere?",
	"InsuranceProviderInfoCardNoProviderParagraph": "Hvis du har gratis tilgang til Hejdoktor gjennom en samarbeidspartner som dekker denne behandlingen, må du koble den til i profilen din før du booker.",
	"InsuranceProviderInfoCardGoToProfile": "Gå til profil",
	"AccessVia": "Tilgang via",
	"Attachments": "Vedlagte filer",
	"AdultWarningBookingTitle": "Du kan ikke henvende deg på vegne av andre voksne",
	"AdultWarningBookingText": "Voksne medlemmer av husstanden og barn over {0} år må ha sin egen profil for at vi skal kunne hjelpe dem. Hvis du har tilgang gjennom en av våre samarbeidspartnere, kan du invitere husstandsmedlemmene dine via profilen din.",
	"GoToProfile": "Gå til profil",
	"OtherHouseholdmembers": "Husstandsmedlemmer over {0} år",
	"CurrentPetWeight": "Dyrets nuværende vægt",
	"PleaseEnterANumber": "Indtast venligst et tal. Du må gerne bruge decimaler (fx 5,2 eller 5.2)",
	"KilosSuffix": "kg",
	"CurrentPetWeightHelperText": "Ved mistanke om forgiftning er dyrets vægt vigtig. Kender du ikke vægten, så skriv dit bedste bud.",
	"CurrentPetWeightPlaceholder": "Fx \"5,2\""
}